import { getPublicEnv } from "@/config/get-public-env";

export const DEFAULT_THEME = getPublicEnv().NEXT_PUBLIC_DEFAULT_THEME;

/** The mode (light, dark or follow the device) shown until the visitor chooses one; the owner can change it in Settings > App brand (appBrand.defaultMode), this is its factory value and the fallback before the page is read. */
export const DEFAULT_MODE = "system" as const;

export type ThemeMode = "light" | "dark" | "system";

export const isMode = (v: unknown): v is ThemeMode => v === "light" || v === "dark" || v === "system";
